import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';
import './shared/ui/dailyOverlay.css';

/**
 * The site used to run on a HashRouter, so every page lived at `/#/play/x`.
 * Search engines ignore the fragment, which collapsed the whole site into one
 * indexable URL — and shared links (including the Longshot ticket's) still
 * carry the old form. Rewrite them to the real path before React mounts, so an
 * old link lands on the right page instead of the hub.
 */
const { hash, pathname, search } = window.location;
if (hash.startsWith('#/')) {
  const target = hash.slice(1);
  window.history.replaceState(null, '', target);
} else if (hash === '#' && pathname === '/') {
  window.history.replaceState(null, '', pathname + search);
}

/**
 * The prerendered copy of the page's evergreen content. React renders the same
 * content from the same source once it mounts, so this static copy is removed
 * to avoid showing it twice. A crawler that never runs JS keeps it.
 */
document.getElementById('seo')?.remove();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
